import React from "react";
import styles from "./styles.module.css";

interface ToggleButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ isCollapsed, onClick }) => {
  return (
    <button onClick={onClick} className={styles.toggleButton}>
      <img
        src="/assets/icons/arrowsidebar.svg"
        alt="Arrow"
        width={20}
        height={20}
        className={isCollapsed ? styles.collapsed : styles.expanded}
      />
    </button>
  );
};


